import { isDateEqual, formatDayTime, isEndChatSuveyValid, isEndChatGreetingValid } from '@/services/utils'
import upload from '@/services/upload'
import Storage from '@/services/storageLib'
import AppWarn from '@/services/errors/app-warns'
import { isUserLoggedIn, getTranslation, isTypeBOT, clearTimerForEndChat, getCdnBaseUrl, getScheduledAlert, getUpcomingScheduledAlert, convertUTCTimestampToLocalTimestamp, isMediumPriorityAlertValid, hasConversationInitiated } from '@/services/utils'
import updateChatWidget from '@/services/updateChatWidget'
import {constantStrings, jsonConfigTemplate} from '@/services/constants'
import { transcriptHistory } from '@/services/emailTranscript'
import i18n from '@/services/localization/i18n-setup'
import { GlobalVars } from '@/services/globals'
import audioUtil from '../../services/audioUtil'
import { emitEventToParentWindow } from '../../services/utils'
import { eventType } from '../../services/constants'
import store from '@/store'

export default {
    updateBrowserFontSizeSetting({ commit }, value) {
      commit('UPDATE_BROWSER_FONT_SIZE_SETTING', value)
    },
    updateBotConfig({ commit, rootState }, config) {
      const widgetConfig = rootState.widgetConfig
      
      if (!widgetConfig.cssConfig) {
        widgetConfig.cssConfig = {}
      }
    
      const keys = ['chatWidget', 'supportIconConfig', 'launchButton', 'theme', 'borderRadius', 'botResponseBubbleColor', 'logoImage']
    
      keys.forEach((key) => {
        if (config[key] !== undefined) {
          if (typeof config[key] === 'object' && !Array.isArray(config[key])) {
            widgetConfig[key] = {
              ...(widgetConfig[key] || {}),
              ...(config[key] || {})
            }
          } else {
            widgetConfig[key] = config[key]
          }
          delete config[key]
        }
      })
      const clientConfigs = ['endChat']
      clientConfigs.forEach((key) => {
        if(config[key] !== undefined) {
          rootState.clientConfigs[key] = {
            ...(rootState.clientConfigs[key] || {}),
            enabled: true,
            config: {
              ...(rootState.clientConfigs[key]?.config || {}),
              ...(config[key] || {})
            }
          }
          delete config[key]
        }
      })
      
    
      widgetConfig.cssConfig = {
        ...widgetConfig.cssConfig,
        ...config
      }
      commit('UPDATE_WIDGET_CONFIG', widgetConfig)
    },
    updateSupportIconState({ commit }, data) {
      commit('UPDATE_SUPPORT_ICON_STATE', data)
    },
    updateInputFieldHiddenStatus({ commit }, data) {
      commit('UPDATE_INPUT_FIELD_HIDDEN_STATUS', data)
    },
    updateTermsAndConditions({ commit, rootState }) {
      if (!hasConversationInitiated()) {
        const termsAndConditions = rootState.widgetConfig?.termsConfig?.terms
        const activeTerm = termsAndConditions?.find(({ isActive, isArchived }) => isActive && !isArchived)
        if (termsAndConditions?.length && activeTerm) {
          commit('UPDATE_TERMS_AND_CONDITIONS_STATE', {...rootState.termsAndConditions, terms: activeTerm})
        }
      }
    },
    updateAlerts({ rootState, commit }) {
      const alertsConfig = rootState.widgetConfig?.alertsConfig
      const highPriorityAlerts = alertsConfig?.highPriorityAlerts
      if (highPriorityAlerts?.length) {
        const scheduledHighPriorityAlert = getScheduledAlert(highPriorityAlerts)
        if (scheduledHighPriorityAlert) {
          commit('UPDATE_HIGH_PRIORITY_ALERT_STATE', scheduledHighPriorityAlert)
          setTimeout(() => {
            commit('UPDATE_HIGH_PRIORITY_ALERT_STATE', {})
          }, Math.min(convertUTCTimestampToLocalTimestamp(scheduledHighPriorityAlert.schedule.startEndDateTime[1] - scheduledHighPriorityAlert.schedule.utcOffsetInMs) - Date.now(), 2147483647))
        } else {
          const {upcomingScheduledHighPriorityAlert , delay} = getUpcomingScheduledAlert(highPriorityAlerts)
          if (upcomingScheduledHighPriorityAlert) {
            setTimeout(() => {
              commit('UPDATE_HIGH_PRIORITY_ALERT_STATE', upcomingScheduledHighPriorityAlert)
              setTimeout(() => {
                commit('UPDATE_HIGH_PRIORITY_ALERT_STATE', {})
              }, Math.min(convertUTCTimestampToLocalTimestamp(upcomingScheduledHighPriorityAlert.schedule.startEndDateTime[1] - upcomingScheduledHighPriorityAlert.schedule.utcOffsetInMs) - Date.now(), 2147483647))
            }, Math.min(delay, 2147483647))
          }
        }
      }
      const mediumPriorityAlerts = alertsConfig?.mediumPriorityAlerts
      if (mediumPriorityAlerts?.length && isMediumPriorityAlertValid()) {
        const scheduledMediumPriorityAlert = getScheduledAlert(mediumPriorityAlerts)
        if (scheduledMediumPriorityAlert) {
          commit('UPDATE_MEDIUM_PRIORITY_ALERT_STATE', scheduledMediumPriorityAlert)
          setTimeout(() => {
            commit('UPDATE_MEDIUM_PRIORITY_ALERT_STATE', {})
          }, Math.min(convertUTCTimestampToLocalTimestamp(scheduledMediumPriorityAlert.schedule.startEndDateTime[1] - scheduledMediumPriorityAlert.schedule.utcOffsetInMs) - Date.now(), 2147483647))
        }
      }
    },
    updateMediumPriorityAlertState({ commit }, data) {
      commit('UPDATE_MEDIUM_PRIORITY_ALERT_STATE', data)
    },
    updateTermsState({ commit, rootState }, data) {
      commit('UPDATE_TERMS_AND_CONDITIONS_STATE', { ...rootState.termsAndConditions, terms: data })
    },
    updateGreetingTriggerOnAlertClosureState({ commit }, data) {
      commit('UPDATE_GREETING_TRIGGER_ON_ALERT_CLOSURE_STATE', data)
    },
    updateGreetingTriggerOnTermsClosureState({ commit }, data) {
      commit('UPDATE_GREETING_TRIGGER_ON_TERMS_CLOSURE_STATE', data)
    },
    updateQuickReplyOnTermsClosureState({ commit }, data) {
      commit("UPDATE_QUICK_REPLY_ON_TERMS_CLOSURE_STATE" , data)
    },
    updateBlankScreenState({ commit, rootState }, data) {
      const currentTimerId = rootState.blankScreen.timerId
      if (currentTimerId) {
        clearTimeout(currentTimerId)
      }
      commit('UPDATE_BLANK_SCREEN_STATE', data)
    },
    deleteChatAtIthPosition({ commit }, position) {
      commit('DELETE_CHAT_AT_ITH_POS', position)
    },
    updateUserDeviceDetails({ commit }, userDeviceDetails) {
      commit('UPDATE_USER_DEVICE_DETAILS', userDeviceDetails)
    },
    updateCookieValuesCopyState({commit}, data) {
      commit('UPDATE_COOKIE_VALUES_COPY_STATE', data)
    },
    updateTriggerMinimizeValidState({commit}, data) {
      commit('UPDATE_TRIGGER_MINIMIZE_VALID_STATE', data)
    },
    updateUnreadMessagesState({commit}, data) {
      commit('UPDATE_UNREAD_MESSAGES_STATUS', data)
    },
    updateKnowledgeAISources({commit}, data) {
      commit('UPDATE_KNOWLEDGE_AI_SOURCES', data)
    },
    updateUserIPAddress({commit}, data) {
      commit('UPDATE_USER_IP_ADDRESS', data)
    },
    
    updateBotDetails({ commit }, data) {
      commit('UPDATE_BOT_DETAILS', data)
    },

    updatePreLoaderEnabledStatus({commit}, data) {
      commit('UPDATE_PRE_LOADER_ENABLED_STATUS', data)
    },

    updateOverlayStatus({ commit}, data) {
        commit('UPDATE_OVERLAY_STATUS', data)
    },

    updateChatWindowFullScreenState({ commit }, data) {
        commit('UPDATE_CHAT_WIDGET_FULLSCREEN_STATUS', data)
          commit('UPDATE_CALLOUT_BUBBLE_ENABLED_FLAG', isUserLoggedIn() ? !Storage.getSessionStorageData('userInteracted') : false)
    },
    
    updateFileAttachmentIcon({ commit }, data) {
        commit('UPDATE_FILE_ATTACHMENT_ICON', data)
    },
    
    toggleChatWindowStatus({ commit, getters }, data) {
        commit('TOGGLE_CHAT_WINDOW_STATUS', {data, getters})
        commit('UPDATE_CALLOUT_BUBBLE_ENABLED_FLAG', isUserLoggedIn())
        commit('UPDATE_VOICE_MODE', false)
        audioUtil.endAudio()
    },

    removeLastChatBlock({ commit }) {
        commit('REMOVE_LAST_CHAT_BLOCK')
    },
    
    updateQuickReplyOptions({ commit }, data) {
        commit('UPDATE_QUICK_REPLY_OPTIONS', data)
    },

    updateActionableNBAOptions({ commit }, data) {
      commit('UPDATE_ACTIONABLE_NBA_OPTIONS', data)
    },

    updateNonActionableNBAOptions({ commit }, data) {
      commit('UPDATE_NON_ACTIONABLE_NBA_OPTIONS', data)
    },

    updateNonActionableNBAOverlayEnabled({ commit }, data) {
      commit('UPDATE_NON_ACTIONABLE_NBA_OVERLAY_ENABLED', data)
    },
    
    updateTypingIndicatorStatus({ commit }, data) {
        commit('UPDATE_INDICATOR_STATUS', data)
    },

    showMessageSeparator({ commit, rootState }, data) {
      const isPreviousLoader = rootState.previousCoversationLoader
      const COMMIT = isPreviousLoader ? 'UPDATE_PREVIOUS_CHAT' : 'UPDATE_CHATS'
      const payload = isPreviousLoader ? { position: 0, chatBlock: data } : data
      commit(COMMIT, payload)
      
    },
    
    showDayDateSeparator({ commit, dispatch, getters, rootState }, data) {
        const currentTimestamp = Number(data.messagePayload.timestamp)
        const previousConversationTimestamp = getters.getLastMessageTimestamp
        if (
          previousConversationTimestamp &&
          isDateEqual(currentTimestamp, previousConversationTimestamp)
        ) {
          // If Day/Date is not present on first chat block
          if (!rootState.chats?.[0]?.isMessageSeparator) {
            commit('UPDATE_PREVIOUS_CHAT', {
              position: 0,
              chatBlock: {
                isMessageSeparator: true,
                content: {
                  component: 'DateSeparator',
                  message: formatDayTime(currentTimestamp)
                },
                timestamp: Date.now()
              }
            })
          }
          // Show Day/Date separator for current Chat block
          dispatch('showMessageSeparator', {
            isMessageSeparator: true,
            content: {
              component: 'DateSeparator',
              message: formatDayTime(currentTimestamp)
            },
            timestamp: Date.now()
          })
        }
    },
    
    setEndChatTimer({ rootState, commit, dispatch }, {delay, isGuest}) {
      clearTimerForEndChat()
      if(isGuest) {
        const timerId = setTimeout(() => {
          const isEndChatSurveyTriggered = isEndChatSuveyValid()
          const hideEndChatGreeting = rootState.widgetConfig.endChat ? rootState.widgetConfig?.endChat?.isSendTranscriptEnabled : true
          const isMinimizeValid = !isEndChatSurveyTriggered && !isEndChatGreetingValid(hideEndChatGreeting)
          isEndChatSurveyTriggered && dispatch('updateTriggerMinimizeValidState', true)
          dispatch('endChat', {
            message: constantStrings.SESSION_HAS_EXPIRED,
            hideEndChatGreeting
          })
          isMinimizeValid && dispatch('minimizeCW')
          updateChatWidget.updateScript();
        }, delay)
        commit('UPDATE_IDLE_TIMEOUT_ID', timerId)
      }
    },

    overlayIdleChatTimeout({ commit, dispatch, rootState }) {
        if(!rootState.widgetConfig?.inactiveOverlay?.inactiveOverlayTimeout) {
          return
        }
        let timerId = rootState.overlayTimerId
        const delay = rootState.widgetConfig?.inactiveOverlay?.inactiveOverlayTimeout
        if (timerId) {
          clearTimeout(timerId)
        }
        timerId = setTimeout(async() => {
          dispatch('updateOverlayStatus', true)
          Storage.setLocalStorageData('overlayStatus', true)
          await dispatch('sendIoTEvent',{event_name: 'SHOW_OVERLAY'})
        }, delay)
        commit('UPDATE_OVERLAY_IDLE_TIMEOUT_ID', timerId) 
    },

    async uploadOnS3(_, data) {
        const isFileScanEnabled = store.getters.scanFileForMalwareEnabled
        if(isFileScanEnabled) {
          const result = await upload.scanFileForMalware(data.file)
          if(result.isInfected) {
            throw new Error(`Failed to upload file. File is infected with malware`)
          }
        }
        let uploadUrl, uploadParams
        try {
          const response = await upload.getPreSignedPostURL({
            fileType: data.file.type,
            uploadKeyPrefix: data.uploadKeyPrefix
          })
          uploadUrl = response.url
          uploadParams = response.fields
        } catch (err) {
          console.log('Error while uploading file', err.message)
          throw new AppWarn({name: 'Action', message:`Error occurred while uploading file. ${err.message}`})
        } finally {
          await upload.uploadFileToS3ByPreSignedURL(
            data.file,
            uploadUrl,
            uploadParams
          )
        }
        let key = uploadParams?.key
        key = key?.substring(key?.indexOf("/media"))
        return key && `${getCdnBaseUrl()}${key}`
    },

    setIsCalloutBubbleEnabled({ commit }, data = true) {
      commit('UPDATE_CALLOUT_BUBBLE_ENABLED_FLAG', data)
    },

    updateCalloutBubbleFlagFromPubsub({ commit }, calloutBubble = { enabled: true }) {
      commit('UPDATE_CALLOUT_BUBBLE_FLAG_FROM_PUBSUB', calloutBubble)
    },

    showCalloutBubbleFromPubsub({ commit, dispatch }, data) {
      if (typeof data === 'boolean') {
        dispatch('updateCalloutBubbleFlagFromPubsub', { enabled: data })
      } else if (typeof data === "object") {
        dispatch('updateCalloutBubbleFlagFromPubsub', { enabled: true, data })
        commit('UPDATE_CALLOUT_BUBBLE', data)
      }
    },

    updateQuickMenuState({ commit, dispatch, rootState}, data) {
      let options = data.type === constantStrings.QUICK_MENU ? rootState.widgetConfig?.quickMenuOptions : {}
      let quickMenuClickHandler;
      switch(data.type) {
        case constantStrings.QUICK_MENU:
          options = rootState.widgetConfig?.quickMenuOptions.map((_,index) => {
            return {label:`${jsonConfigTemplate.QUICK_MENU_OPTIONS_LABEL}${index+1}`, text: getTranslation(`${jsonConfigTemplate.QUICK_MENU_OPTIONS_TEXT}${index+1}`)}
          })
          quickMenuClickHandler = function (_,index) {
            dispatch('sendMessage',{
              userMessage: {
                payload: getTranslation(`${jsonConfigTemplate.QUICK_MENU_OPTIONS_TEXT}${index+1}`),
                label: getTranslation(`${jsonConfigTemplate.QUICK_MENU_OPTIONS_LABEL}${index+1}`)
              }
            });
          }
          break;
        default:
          break;
      }

      commit('UPDATE_QUICK_MENU_STATE', {type: data.type, options})
      commit('UPDATE_QUICK_MENU_HANDLER', quickMenuClickHandler)
    },

    updateQuickMenuVisibility({ commit }, data) {
      commit('UPDATE_QUICK_MENU_VISIBILITY', data)
    },

    updateLocale(_, locale) {
      i18n.updateLocaleAndMessages(locale)
      Storage.setLocalStorageData(constantStrings.CURRENT_LOCALE, locale)
    },

    updateWidgetVisitorInfo({ commit }, widgetVisitorInfo) {
      commit('UPDATE_WIDGET_VISITOR_INFO', widgetVisitorInfo)
    },

    updateDefaultAttributes({ commit }, defaultAttributes) {
      commit('UPDATE_DEFAULT_ATTRIBUTES', defaultAttributes)
    },

    updateNotificationSound({ commit }, value) {
      commit('UPDATE_NOTIFICATION_SOUND', value)
    },
    updateInternetConnectionStatus({ commit }, data = true) {
      commit('UPDATE_CONNECTION_STATUS', data)
    },
    updateIsCalloutBubbleLoadedStatus({ commit }, data) {
      commit('UPDATE_CALLOUT_BUBBLE_LOADED', data)
    },
    updateFocusEnable({ commit }, data) {
      commit('UPDATE_FOCUS_ENABLE', data)
    },
    updateFocusNode({ commit }, data) {
      commit('UPDATE_FOCUS_NODE', data)
    },
    showExternalHeaderText({ commit }, data) {
      commit('SHOW_EXTERNAL_HEADER_TEXT', data)
    },
    showHeaderMenuButtons({ commit }, data) {
      commit('SHOW_HEADER_MENU_BUTTONS', data)
    },
    updateCsatSurveyTime({ commit }, data) {
      commit('UPDATE_CSAT_SURVEY_TIME', data)
    },
    updatePromptTestDetails({ commit }, data) {
      commit('UPDATE_PROMPT_TEST_DETAILS', data)
    },
    updateVoiceModeActive({commit},data) {
      commit('UPDATE_VOICE_MODE',data)
    },
    updateVoiceState({commit},data) {
      commit('UPDATE_VOICE_STATE',data)
    },
    showVisitorInfoButton({ commit }, data) {
      commit('SHOW_VISITOR_INFO_BUTTON', data)
    },
    showVisitorInfoForm({ commit }, data) {
      commit('SHOW_VISITOR_INFO_FORM', data)
    },
    updateVisitorInfoForm({ commit, getters}, data) {
      commit('UPDATE_VISITOR_INFO_FORM', data)
      if (getters.isResponseAnalyzerEnabled) {
        emitEventToParentWindow(eventType.RA_UPDATE_VISITOR_INFO_FORM, {data})
      }
    },
    async backToBotAction() { 
        if(!isTypeBOT()) {
            await GlobalVars.$liveAgent.endChatWithLiveAgent()
        } 
    },
    async transcriptMessage() {
      await transcriptHistory()
    }
}
